// modifer: styles/jss/nextjs-material-kit-pro/pages/productStyle"
import { section } from 'styles/jss/original/base';

const styles = {
  section: {
    ...section,
    padding: '0'
  }
};

export default styles;
